import { Button, NavigationPopup, Text } from "@capioweb/ui-components/src"
import React from "react"
import { LinkProperty } from "../../../@types/EpiFoundationSpa/Property"
import {
	isSessionStorageAvailable,
	sendLogInPopUpClickDataLayerPush,
} from "../../../utils"
import { HeaderContext } from "../context/HeaderContext"

interface LoginProps {
	loginMenuHeading: string
	loginMenuPreamble: string
	loginItems: LinkProperty[]
}

const LoginPopup: React.FC<LoginProps> = (props) => {
	const { setShowLoginWindowPopup } =
		React.useContext(HeaderContext)
	return (
		<>
			<NavigationPopup
				size={"small"}
				heading={props.loginMenuHeading}
				showPopup={setShowLoginWindowPopup}
				isSearchPopup={false}
				arrowOffset='22px'
			>
				<Text my={2}>{props.loginMenuPreamble}</Text>
				{props.loginItems?.length > 0 &&
					props.loginItems.map((item, i) => {
						return (
							<Button.Anchor
								variant="navy"
								key={item.contentLink?.id ?? `loginItem-${i}`}
								my={1}
								href={item.href}
								style={{ width: "100%" }}
								onClick={() => {
									sendLogInPopUpClickDataLayerPush(
										props.loginItems[i].text ?? ""
									)
									setShowLoginWindowPopup(false)
									if (isSessionStorageAvailable()) {
										sessionStorage.setItem("hideLoginPopup", "1")
									}
								}}
							>
								{item.text}
							</Button.Anchor>
						)
					})}
			</NavigationPopup>
		</>
	)
}

export { LoginPopup }
